/// <amd-module name="VSSUI/Components/ResizeGroup/OverflowButton" />
import * as React from "react";
import { IMenuItem } from "../Menu/Menu.Props";
import { IResizeGroupContext } from "./ResizeGroup.Props";
import { MoreButton } from "../Menu/MoreButton";
import { Observer } from "VSSUI/Observer";
import { ResizeGroupContext } from "./ResizeGroup";
import { IButtonProps } from "../Button/Button.Props";
import { IFocusable } from "VSSUI/Utilities/Focus";

export class OverflowButton extends React.Component<IButtonProps> implements IFocusable<{}> {
    private moreButton = React.createRef<MoreButton>();

    public render(): JSX.Element {
        return (
            <ResizeGroupContext.Consumer>
                {(resizeGroupContext: IResizeGroupContext): JSX.Element => {
                    return (
                        <Observer menuItems={resizeGroupContext.overflowItems}>
                            {(props: { menuItems: IMenuItem[] | undefined }) =>
                                props.menuItems && props.menuItems.length > 0 ? (
                                    <MoreButton
                                        contextualMenuProps={{
                                            menuProps: { id: "overflow-menu", items: props.menuItems }
                                        }}
                                        ref={this.moreButton}
                                        {...this.props}
                                    />
                                ) : (
                                    <div />
                                )
                            }
                        </Observer>
                    );
                }}
            </ResizeGroupContext.Consumer>
        );
    }

    public focus(): void {
        if (this.moreButton.current) {
            this.moreButton.current.focus();
        }
    }
}
